// @json
import textEn from './text-en.json';

export default {
    en: textEn
};
